import { Col, Row } from "react-bootstrap";
import { Field, useForm, useFormState } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import { Button, Icon, Tooltip } from "@mui/material";
import BMXButton from "../../../../../../Components/Buttons/BMXButton/BMXButton";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { useCallback, useState } from "react";
import { NotificationManager } from "react-notifications";
import store from "../../../../../../store";
import { hide, show } from "redux-modal";

const CrmPotentialFormStepOne = (props) => {
  const { t } = useTranslation();
  const form = useForm();
  const formState = useFormState();
  const [loading, setLoading] = useState(false); // loading state
  const { dispatch } = store;
  const HideModal = (name) => dispatch(hide(name));
  const ShowModal = (name, props) => dispatch(show(name, props));

  const handleGptPromptClick = async () => {
    const { contractor: { name, nip } = {} } = props.initialValues || {};

    if (!name) {
      NotificationManager.error("Brak nazwy firmy");
      return;
    }
    if (!nip) {
      NotificationManager.error("Brak numeru NIP firmy");
      return;
    }

    setLoading(true);

    // Mapowanie: klucz JSON → klucz tłumaczenia (z i18n)
    const fieldTranslationMap = {
      industry: "global:crm.industry",
      clientTerritorialScope: "global:crm.clientTerritorialScope",
      websiteOpinion: "global:crm.websiteOpinion",
      marketData: "global:crm.marketData",
      employeeCount: "global:crm.employeeCount",
      shareCapital: "global:crm.shareCapital",
      marketOpinion: "global:crm.marketOpinion",
      employeeFeedback: "global:crm.employeeFeedback",
      summary: "global:crm.summary",
    };

    // Tworzenie struktury JSON z przetłumaczonymi nazwami jako wartości
    const translatedJsonTemplate = Object.entries(fieldTranslationMap).reduce(
      (acc, [key, translationKey]) => {
        acc[key] = t(translationKey);
        return acc;
      },
      {}
    );

    const prompt = `
Firma o nazwie: "${name}" (NIP: "${nip}").
Proszę wygeneruj odpowiedź w formacie JSON z następującymi polami, gdzie każda wartość jest stringiem i zawiera krótki tekst opisujące pole.
Poniżej znajdują się klucze oraz ich znaczenie:

${JSON.stringify(translatedJsonTemplate, null, 2)}

Odpowiedz tylko jako czysty JSON, bez komentarzy, bez dodatkowego tekstu. Jeśli nie znajdziesz informacji — pozostaw pole puste.
`;

    try {
      const { payload } = await GlobalAuthFetch({
        path: "/chatgpt-api/create-prompt",
        method: "POST",
        data: JSON.stringify({ prompt }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const content =
        payload?.data?.choices?.length > 0
          ? payload.data.choices[0].message.content
          : null;

      if (!content) {
        NotificationManager.error("Brak odpowiedzi z ChatGPT");
        return;
      }

      let jsonResponse;
      try {
        jsonResponse = JSON.parse(content);
      } catch (e) {
        NotificationManager.error("Odpowiedź nie jest poprawnym JSON");
        console.error("Błąd parsowania JSON:", e);
        return;
      }

      Object.entries(jsonResponse).forEach(([key, value]) => {
        if (form && typeof form.change === "function") {
          form.change(key, value);
        }
      });
    } catch (err) {
      console.error("Błąd podczas wywołania ChatGPT:", err);
      NotificationManager.error("Błąd podczas wywołania ChatGPT");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmGptClick = () => {
    ShowModal("ConfirmModal", {
      confirmButtonName: "global:crm.confirmAskChat",
      mainText: "global:crm.confirmAskChat",
      contentText: "global:crm.additionalInfo",
      onSubmit: async () => {
        HideModal("ConfirmModal");
        await handleGptPromptClick();
      },
      onCancel: () => {
        HideModal("ConfirmModal");
      },
    });
  };

  return (
    <div
      className="PotentialFormStepOne"
      style={{ justifyContent: "flex-start" }}
    >
      <BMXSeparator title={t("global:crm.potentialBasicInformation")} />
      <Row>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.industry")}`}
            name="industry"
            data-cy="industry"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.clientTerritorialScope")}`}
            name="clientTerritorialScope"
            data-cy="clientTerritorialScope"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.websiteOpinion")}`}
            name="websiteOpinion"
            data-cy="websiteOpinion"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.marketData")}`}
            name="marketData"
            data-cy="marketData"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.employeeCount")}`}
            name="employeeCount"
            data-cy="employeeCount"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.shareCapital")}`}
            name="shareCapital"
            data-cy="shareCapital"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.marketOpinion")}`}
            name="marketOpinion"
            data-cy="marketOpinion"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.employeeFeedback")}`}
            name="employeeFeedback"
            data-cy="employeeFeedback"
          />
        </Col>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.summary")}`}
            name="summary"
            data-cy="summary"
          />
        </Col>

        {/* FETCH AI BUTTON */}
        <Col xs={6}>
          <div
            style={{
              display: "flex",
              gap: "5px",

              alignItems: "center",
            }}
          >
            <Tooltip title={t("global:crm.askChatGpt")} placement="right">
              <Button
                sx={{
                  backgroundColor: "#fecc00",
                  color: "#fff",
                  width: 40,
                  height: 40,
                  minWidth: 0,
                  borderRadius: "50%",
                  padding: 0,
                  "&:hover": {
                    backgroundColor: "#b39905",
                  },
                  opacity: loading ? 0.7 : 1,
                  pointerEvents: loading ? "none" : "auto",
                }}
                onClick={handleConfirmGptClick} // Zmienione na confirm
                disabled={loading}
              >
                {loading ? (
                  <Icon style={{ fontSize: "20px", color: "#fff" }}>
                    hourglass_top
                  </Icon>
                ) : (
                  <span className="text white">AI</span>
                )}
              </Button>
            </Tooltip>
            <div>{loading ? <span>Trwa ładowanie wyników...</span> : ""}</div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CrmPotentialFormStepOne;
